module.exports = __webpack_public_path__ + "img/list-ol.f33e7191.svg";